import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRequest } from "../../../services/api";
import { slugify } from "../../../utils/slugify";
import "../../../pages/AllBlogs/BlogShared.css";
import "./RelatedBlogs.css";

const RelatedBlogs: React.FC = () => {
  const [blogs, setBlogs] = useState<any[]>([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await getRequest("/blogs", { category: "mcqs", limit: 10 });
        setBlogs(response.data.blogs);
      } catch (err) {
        console.error("Error fetching related blogs:", err);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div className="bl-card bl-related">
      {/* Header */}
      <div className="bl-related-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
        Recent MCQ Posts
      </div>

      {/* List */}
      <div className="bl-related-list">
        {blogs.length === 0 ? (
          <div className="bl-related-empty">Loading posts…</div>
        ) : (
          blogs.slice(0, 10).map((item) => (
            <Link
              key={item._id}
              to={`/mcqs/mcqs-post/${slugify(item.category_name)}/${slugify(
                item.sub_category_name.replace(/\0/g, "").trim()
              )}/${item.slug}`}
              state={{ id: item._id }}
              className="bl-related-item"
            >
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.header_title}
                  className="bl-related-thumb"
                  loading="lazy"
                />
              ) : (
                <div className="bl-related-thumb-placeholder">📝</div>
              )}
              <div className="bl-related-info">
                <div className="bl-related-name">{item.header_title}</div>
                <div className="bl-related-date">
                  {item.created_at
                    ? new Date(item.created_at).toLocaleDateString("en-IN", {
                        day: "numeric", month: "short", year: "numeric",
                      })
                    : ""}
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default RelatedBlogs;
